import webcolors from 'webcolors/webcolors'
import templateUrl from 'webcolors/color-spectrum.htm'
import scss from 'webcolors/color-spectrum.scss'
import resolve from 'ioc/resolve'
import angular from 'angular'
const $ = angular.element;

function ColorSpectrumDirective($timeout, $window) {
    return {
        restrict: 'AE',
        templateUrl,
        replace: true,
        require: '?ngModel',
        scope: {},
        link ($scope, $element, $attributes, ngModel) {
            //console.warn('ColorSpectrumDirective', ColorSpectrumDirective);
            //console.warn('ngModel', ngModel);
            //console.warn('$attributes', $attributes);
            $scope.hsv = { h: 0, s: 0, v: 0 };

            if (ngModel) {
                ngModel.$render = function () {
                    if (/^#[0-9A-Fa-f]{6}$/.test(ngModel.$viewValue)) {
                        $scope.color = ngModel.$viewValue;
                        $scope.hsv = webcolors.hexRgbToHsv($scope.color);
                        $scope.colorCursor = {
                            x: $scope.hsv.s * 200,
                            y: (1 - $scope.hsv.v) * 200
                        };
                    } else {
                        $scope.color = null;
                        $scope.hsv = { h: 0.5 };
                        $scope.colorCursor = null;
                    }

                    $scope.hueBackgroundColor = webcolors.hsvToHexRgb($scope.hsv.h, 1, 1);
                    $scope.hueCursor = $scope.hsv.h * 200;
                };
            }

            var dragSubject,
                dragRect;

            function doDrag(x, y) {
                x = Math.max(Math.min(x, dragRect.width), 0);
                y = Math.max(Math.min(y, dragRect.height), 0);

                if (dragSubject === 'hue') {
                    $scope.hueCursor = y;

                    $scope.hsv.h = y / dragRect.height;

                    $scope.hueBackgroundColor = webcolors.hsvToHexRgb($scope.hsv.h, 1, 1);
                } else {
                    $scope.colorCursor = {
                        x: x,
                        y: y
                    };

                    $scope.hsv.s = x / dragRect.width;
                    $scope.hsv.v = 1 - y / dragRect.height;
                }

                if (typeof $scope.hsv.s !== 'undefined') {
                    $scope.color = webcolors.hsvToHexRgb($scope.hsv);

                    if (ngModel) {
                        ngModel.$setViewValue($scope.color);
                    }
                }
            }

            function onMouseMove(evt) {
                evt.preventDefault();

                $scope.$apply(function () {
                    doDrag(evt.clientX - dragRect.x, evt.clientY - dragRect.y);
                });
            }

            $scope.startDrag = function (evt, subject) {
                var rect = evt.target.getBoundingClientRect();

                dragSubject = subject;
                dragRect = {
                    x: rect.left,
                    y: rect.top,
                    width: rect.right - rect.left,
                    height: rect.bottom - rect.top
                };

                doDrag(evt.offsetX || evt.layerX, evt.offsetY || evt.layerY);

                $($window)
                    .on('mousemove', onMouseMove)
                    .one('mouseup', function () {
                        $($window).off('mousemove', onMouseMove);
                    });
            };
        }
    };
};

export default ColorSpectrumDirective;